import { InjectionKey, Ref } from 'vue';

// This follows the recommendation for typing Provide/Inject: https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject
export const radioButtonGroupKey = Symbol('radioButtonGroupKey') as InjectionKey<{
    activeId: Ref<string | undefined>;
    name: Ref<string>;
    onChange: (activeId: string) => void;
}>;
